import io from 'socket.io-client';
const SOCKET_URL = 'https://logo-api.apps.automatec.com.au'; // Your NestJS backend URL
export const socket = io(SOCKET_URL);
